import {
	RDX_ESG_QUESTIONNAIRE_DATA_DONE,
	RDX_ESG_QUESTIONNAIRE_RESPONSES_DONE,
	RDX_ESG_QUESTIONNAIRE_VALIDATE,
	RDX_ESG_QUESTIONNAIRE_UPDATE_VALIDATE,
	RDX_ESG_QUESTIONNAIRE_UPDATE_RESPONSE,
	RDX_ESG_UPDATE_REPORT_DOCUMENT_ID_STATUS
} from './esgAction';
import esgConverter from '../converter/esgConverter';

const initial = {
	questionnaire: {
		acknowQuestionnaireList: [],
		acknowAnswerList: [],
		assessAnswerList: []
	},
	questionAnswers: [],
	questionnaireResult: {
		customerId: '',
		resultType: '',
		finalCode: '',
		captureDateTime: '',
		expiryDate: '',
		staffId: '',
		historyList: []
	},
	customerName: '',
	accountNum: '',
	questionResponse: null,
	questionResponseIndex: null,
	reportDocumentIdStatus: { 'key': null, 'status': null }
};

const environmentalSocialGovernance = (state = initial, action) => {
	let newState = { ...state };
	switch (action.type) {
		case RDX_ESG_QUESTIONNAIRE_DATA_DONE:
			newState.questionnaire = action.data;
			return { ...newState };
		case RDX_ESG_QUESTIONNAIRE_RESPONSES_DONE:
			newState.questionnaireResult = action.questionnaireResult;
			newState.questionAnswers = newState.questionnaireResult.historyList[0].questionResponse;
			return { ...newState };
		case RDX_ESG_QUESTIONNAIRE_VALIDATE:
			esgConverter.validateInput(action.data, newState.questionnaire);
			return { ...newState };
		case RDX_ESG_QUESTIONNAIRE_UPDATE_VALIDATE:
			esgConverter.updateValidateInput(action.data.questionAnswers, action.data.questionNumber, newState.questionnaire);
			newState.questionAnswers = action.data.questionAnswers;
			return { ...newState };
		case RDX_ESG_QUESTIONNAIRE_UPDATE_RESPONSE:
			newState.questionResponse = action.data.selectedQuestionResponse;
			newState.questionResponseIndex = action.data.selectedQuestionResponseIndex;
			return { ...newState };
		case RDX_ESG_UPDATE_REPORT_DOCUMENT_ID_STATUS:
			newState.reportDocumentIdStatus = action.data;
			return { ...newState };

		default:
			return state;
	}
};

export default environmentalSocialGovernance;